<template>
    <div class="checkout-pay-systems">
<!--        <span v-if="result.title">{{ result.title }}</span>-->
        <ul v-if="result.paySystems">
            <li v-for="paySystem in result.paySystems">
                <label>
                    <!--TODO: не использовать $parent-->
                    <input class="def-radio"
                           @change="$emit('setAjax')"
                           type="radio"
                           name="PAY_SYSTEM_ID"
                           :value="paySystem.ID"
                           :checked="paySystem.CHECKED"
                    >
                    <span class="text">{{ paySystem.NAME }}</span>
                </label>
            </li>
        </ul>
<!--        <div class="def-button" @click="$emit('changeStep', 4)">{{result.messages.nextStep}}</div>-->
    </div>
</template>
<script>
    export default {
        name: "checkout-pay-systems",
        props: ['result'],
        mounted() {
            if (this.$parent.debug) {
                console.log(this.result);
            }
        }
    }
</script>